/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
  <div class="news-chunk" v-if="data[0].list.length > 0 || data[1].list.length > 0">
    <p class="p1">{{$t("home.information")}}</p>
    <div class="content-wrap">
      <div class="news-col" v-for="d in data" v-if="d.list.length>0">
        <div class="header">
          <p class="news-title">{{d.title}}</p>
          <el-button class="more-bnt" type="text" v-if="d.list.length>3" plain size="mini" @click="onMore(d.id)">{{$t("fromData.more")}}></el-button>
        </div>
        <div :class="{'headerReverse':  d.id == 'INDUSTRY', 'headerOrder':  d.id == 'COMPANY'}">
          <img :src="d.id == 'INDUSTRY' ? require('../../../assets/news-hang.jpg') :  require('../../../assets/公司新闻(1).jpg')" alt="" />
          <div class="news-info">
            <div v-for="(item, index) in d.list" class="news-item">
              <!-- <span class="avatar">{{item.title.substr(0, 1)}}</span> -->
              <div class="news-wrap">
                <p class="title" @click="onOpen(item,index)">{{item.title}}</p>
                <p class="date">{{item.createTime}} <span>{{d.title}}</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetNewList } from '../../../api/web'
import moment from "moment"

export default {
  name: "me-news-chunk",
  data() {
    return {
      data: [
        { title: this.$t("menu.company"), id: "COMPANY", list: [] },
        { title: this.$t("menu.industry"), id: "INDUSTRY", list: [] }
      ]
    }
  },
  methods: {
    onOpen(item) {
      this.$router.push({ name: "WEB", query: { newsId: item.newsId } });
    },
    onMore(id) {
      this.$router.push({ name: id });
    },
    init() {
      let _objCom = {
        companyId: 1,
        pageNum: 1,
        pageSize: 4,
        newsType: 0
      };
      let _objInd = {
        companyId: 1,
        pageNum: 1,
        pageSize: 4,
        newsType: 1
      };
      let companyData = [];
      let industryData = [];
      Promise.all([GetNewList(_objCom), GetNewList(_objInd)]).then(res => {
        if (res[0].status) {
          companyData = res[0].data.dataList.map(item => {
            item.createTime = moment(item.createTime).format("YYYY/MM/DD");
            return item
          });
        }
        if (res[1].status) {
          industryData = res[1].data.dataList.map(item => {
            item.createTime = moment(item.createTime).format("YYYY/MM/DD");
            return item
          });
        }
        this.data[0].list = companyData;
        this.data[1].list = industryData;
      })
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped lang="less">
@import "./chunk";

.news-chunk {
  width: 1050px;
  margin: 80px auto;

  .content-wrap {
    margin-top: 60px;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;

    .news-col {
      // width: 48%;
      // display: flex;
      // flex-direction: column;
      margin-bottom: 100px;
      .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
        align-items: center;
      }
      .headerOrder {
        display: flex;
        // justify-content: space-between;
        margin-right: 80px;
        img {
          margin-right: 80px;
        }
      }
      .headerReverse {
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-end;
        .news-info {
          margin-right: 30px;
        }
      }
      .news-info {
        width: 50%;
      }
      @media screen and (min-width: 320px) and (max-width: 480px) {
        .header {
          margin-bottom: 10px;
        }
        .headerOrder {
          flex-direction: column;
          margin-right: 0px;
          img {
            margin-right: 0px;
          }
        }
        .headerReverse {
          flex-direction: column;
          img {
            margin-left: 0px;
          }
        }
        .news-info {
          width: 100%;
          margin-top: 15px;
        }
      }

      .more-bnt {
        color: #435ba1;
        // margin-bottom: 15px;
        // margin-top: 15px;
        align-self: center;
        position: relative;

        // &::before {
        //     position: absolute;
        //     content: " ";
        //     background-color: #435ba1;
        //     width: 240px;
        //     height: 1px;
        //     left: -240px;
        //     top: 50%;
        // }

        // &::after {
        //     position: absolute;
        //     content: " ";
        //     background-color: #435ba1;
        //     width: 240px;
        //     height: 1px;
        //     right: -240px;
        //     top: 50%;
        // }
      }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
      .news-col {
        width: 100%;
        margin-bottom: 40px;
      }
    }

    .news-title {
      color: #435ba1;
      text-align: center;
      font-size: 28px;
    }
    @media screen and (min-width: 320px) and (max-width: 480px) {
      .news-title {
        font-size: 18px;
      }
    }

    .news-item {
      display: flex;
      margin-bottom: 25px;
      align-items: center;

      .avatar {
        width: 65px;
        height: 65px;
        border-radius: 50%;
        flex-shrink: 0;
        border: 2px solid #435ba1;
        text-align: center;
        line-height: 65px;
        font-size: 26px;
        color: #435ba1;
      }

      .news-wrap {
        // margin-left: 15px;
        overflow: hidden;

        .title {
          font-size: 21px;
          /* font-weight: 500; */
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &:hover {
            cursor: pointer;
            color: #435ba1;
          }
        }
        .date {
          font-size: 14px;
        }
      }
    }
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    .content-wrap {
      margin-top: 20px;
    }
    .title {
      font-size: 16px !important;
    }

    .date {
      font-size: 13px;
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px) {
  .news-chunk {
    // margin: -90px 0 20px 0;
    margin: 0px auto;
    overflow: hidden;
    width: 90%;
    .p1 {
      font-size: 24px;
      margin-top: 0px;
    }
  }
}
</style>
